import { Box } from '@ff-it/ui';
import { ReactElement } from 'react';
import { useFilterFields } from '../filter';
import { EntityMap } from '../types';

export function FilterFields({ entities, clients }: { entities: EntityMap; clients?: string[] }): ReactElement {
  const { client, outlet_or_service_category, provider, block } = useFilterFields(entities, clients);
  return (
    <Box display="flex" flexDirection="row" mb="1">
      {client}
      {outlet_or_service_category}
      {provider}
      {block}
    </Box>
  );
}
